var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.189,
    height: 19.189,
    viewBox: "0 0 19.189 19.189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-checkmark-circle-outline",
    "data-name": "Icon ionic-ios-checkmark-circle-outline",
    transform: "translate(-3.375 -3.375)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_37935",
    "data-name": "Path 37935",
    d: "M20.315,13.1l-.812-.835a.175.175,0,0,0-.129-.055h0a.168.168,0,0,0-.129.055l-5.628,5.669-2.048-2.048a.178.178,0,0,0-.258,0l-.821.821a.184.184,0,0,0,0,.263l2.583,2.583a.817.817,0,0,0,.54.263.856.856,0,0,0,.535-.254h0l6.167-6.2A.2.2,0,0,0,20.315,13.1Z",
    transform: "translate(-2.428 -3.038)",
    fill: "#13cc93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37936",
    "data-name": "Path 37936",
    d: "M12.97,4.667A8.3,8.3,0,1,1,7.1,7.1,8.248,8.248,0,0,1,12.97,4.667m0-1.292a9.595,9.595,0,1,0,9.595,9.595A9.593,9.593,0,0,0,12.97,3.375Z",
    fill: "#13cc93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.cce3fa7f3b6050fda9f644c9ddf508ee.svg";
export { ForwardRef as ReactComponent };